import { Component, OnInit, Input } from '@angular/core';
import { Task } from '../../../../api/models/task';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TaskConfirmationDialogComponent } from '../task-confirmation-dialog/task-confirmation-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tasks-icons',
  templateUrl: './tasks-icons.component.html',
  styleUrls: ['./tasks-icons.component.scss']
})
export class TasksIconsComponent implements OnInit {

  @Input() tasks: Task[];

  constructor(
    private modalService: NgbModal,
    private router: Router
    ) { }

  ngOnInit() {
  }

  actionTask(taskSelected: Task) {
    if (taskSelected.taskType === 'RECEIPT OF GOODS') {
      this.router.navigate(['/dashboard',
      {
        outlets: {
          'dashboard-content': ['order-confirmation',
            taskSelected.projectName, taskSelected.accountNumber, taskSelected.orderNumber]
        }
      }]);
    return false;
    } else {
      const modalRef = this.modalService.open(TaskConfirmationDialogComponent, {
        backdrop : 'static',
        keyboard : false
      });
      modalRef.componentInstance.task = taskSelected;
      modalRef.result.then(result => {
        if (result) {
          this.tasks = this.tasks.filter(t => {
            if (t.taskType == 'CABLE CUT') {
              return t.bomLineID !== taskSelected.bomLineID;
            } else {
              return t.taskType !== taskSelected.taskType
            }
          });
        }
      }).catch(() => { });
    }
  }

  getTaskIcon(task: Task): string {
    return '/assets/images/icons/' + task.taskType + '.png';
  }



}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/project-order-summary/tasks-icons/tasks-icons.component.ts